<script setup lang="ts">
import { computed } from "vue";

import { mapGendersByLevel } from "@/common/level";
import vLang from "@/directives/lang";
import { useSettingsStore } from "@/stores";
import type { DictsysArticle } from "@/types";
import type { Level } from "@/types/dictionary";

import ArticleContentWordClass from "./ArticleContentWordClass.vue";

const props = defineProps<{
  dictsysArticle: DictsysArticle;
}>();

const settingsStore = useSettingsStore();
const wordClassLevel = computed<Level>(() => settingsStore.activeWordClassLevel);

const commaSeparatorMap = computed(() => ({
  wordclass:
    props.dictsysArticle.metadata.genders.length ||
    props.dictsysArticle.metadata.irregular ||
    props.dictsysArticle.grammaticalComment,
  genders: props.dictsysArticle.metadata.irregular || props.dictsysArticle.grammaticalComment,
  irregular: props.dictsysArticle.grammaticalComment
}));

function mapGendersToCurrentLevel(genders: string[]) {
  return mapGendersByLevel(
    genders,
    wordClassLevel.value,
    settingsStore.activeLanguageGroup ?? ""
  ).join("/");
}
</script>

<template>
  <i v-if="dictsysArticle.wordclass.key" class="article-content__meta-text mr-1">
    <ArticleContentWordClass :word-class="dictsysArticle.wordclass" /><i
      v-if="commaSeparatorMap.wordclass"
      >,
    </i></i
  >
  <i
    v-if="dictsysArticle.metadata.genders.length"
    v-lang:da
    class="article-content__text article-content__text--light mr-1"
    >{{ mapGendersToCurrentLevel(dictsysArticle.metadata.genders)
    }}<i v-if="commaSeparatorMap.genders">,</i></i
  >
  <i
    v-if="dictsysArticle.metadata.irregular"
    class="article-content__text article-content__text--light mr-1"
    >{{ $t("article.metadata.irregular") }}<i v-if="commaSeparatorMap.irregular">, </i></i
  >
  <i v-if="dictsysArticle.grammaticalComment" class="article-content__meta-text">{{
    dictsysArticle.grammaticalComment
  }}</i>
</template>
